export const timeIntervals = [
  { id: 1, label: '12:00 AM', value: '12:00 AM' },
  { id: 2, label: '12:15 AM', value: '12:15 AM' },
  { id: 3, label: '12:30 AM', value: '12:30 AM' },
  { id: 4, label: '12:45 AM', value: '12:45 AM' },
  { id: 5, label: '01:00 AM', value: '01:00 AM' },
  { id: 6, label: '01:15 AM', value: '01:15 AM' },
  { id: 7, label: '01:30 AM', value: '01:30 AM' },
  { id: 8, label: '01:45 AM', value: '01:45 AM' },
  { id: 9, label: '02:00 AM', value: '02:00 AM' },
  { id: 10, label: '02:15 AM', value: '02:15 AM' },
  { id: 11, label: '02:30 AM', value: '02:30 AM' },
  { id: 12, label: '02:45 AM', value: '02:45 AM' },
  { id: 13, label: '03:00 AM', value: '03:00 AM' },
  { id: 14, label: '03:15 AM', value: '03:15 AM' },
  { id: 15, label: '03:30 AM', value: '03:30 AM' },
  { id: 16, label: '03:45 AM', value: '03:45 AM' },
  { id: 17, label: '04:00 AM', value: '04:00 AM' },
  { id: 18, label: '04:15 AM', value: '04:15 AM' },
  { id: 19, label: '04:30 AM', value: '04:30 AM' },
  { id: 20, label: '04:45 AM', value: '04:45 AM' },
  { id: 21, label: '05:00 AM', value: '05:00 AM' },
  { id: 22, label: '05:15 AM', value: '05:15 AM' },
  { id: 23, label: '05:30 AM', value: '05:30 AM' },
  { id: 24, label: '05:45 AM', value: '05:45 AM' },
  { id: 25, label: '06:00 AM', value: '06:00 AM' },
  { id: 26, label: '06:15 AM', value: '06:15 AM' },
  { id: 27, label: '06:30 AM', value: '06:30 AM' },
  { id: 28, label: '06:45 AM', value: '06:45 AM' },
  { id: 29, label: '07:00 AM', value: '07:00 AM' },
  { id: 30, label: '07:15 AM', value: '07:15 AM' },
  { id: 31, label: '07:30 AM', value: '07:30 AM' },
  { id: 32, label: '07:45 AM', value: '07:45 AM' },
  { id: 33, label: '08:00 AM', value: '08:00 AM' },
  { id: 34, label: '08:15 AM', value: '08:15 AM' },
  { id: 35, label: '08:30 AM', value: '08:30 AM' },
  { id: 36, label: '08:45 AM', value: '08:45 AM' },
  { id: 37, label: '09:00 AM', value: '09:00 AM' },
  { id: 38, label: '09:15 AM', value: '09:15 AM' },
  { id: 39, label: '09:30 AM', value: '09:30 AM' },
  { id: 40, label: '09:45 AM', value: '09:45 AM' },
  { id: 41, label: '10:00 AM', value: '10:00 AM' },
  { id: 42, label: '10:15 AM', value: '10:15 AM' },
  { id: 43, label: '10:30 AM', value: '10:30 AM' },
  { id: 44, label: '10:45 AM', value: '10:45 AM' },
  { id: 45, label: '11:00 AM', value: '11:00 AM' },
  { id: 46, label: '11:15 AM', value: '11:15 AM' },
  { id: 47, label: '11:30 AM', value: '11:30 AM' },
  { id: 48, label: '11:45 AM', value: '11:45 AM' },
  { id: 49, label: '12:00 PM', value: '12:00 PM' },
  { id: 50, label: '12:15 PM', value: '12:15 PM' },
  { id: 51, label: '12:30 PM', value: '12:30 PM' },
  { id: 52, label: '12:45 PM', value: '12:45 PM' },
  { id: 53, label: '01:00 PM', value: '01:00 PM' },
  { id: 54, label: '01:15 PM', value: '01:15 PM' },
  { id: 55, label: '01:30 PM', value: '01:30 PM' },
  { id: 56, label: '01:45 PM', value: '01:45 PM' },
  { id: 57, label: '02:00 PM', value: '02:00 PM' },
  { id: 58, label: '02:15 PM', value: '02:15 PM' },
  { id: 59, label: '02:30 PM', value: '02:30 PM' },
  { id: 60, label: '02:45 PM', value: '02:45 PM' },
  { id: 61, label: '03:00 PM', value: '03:00 PM' },
  { id: 62, label: '03:15 PM', value: '03:15 PM' },
  { id: 63, label: '03:30 PM', value: '03:30 PM' },
  { id: 64, label: '03:45 PM', value: '03:45 PM' },
  { id: 65, label: '04:00 PM', value: '04:00 PM' },
  { id: 66, label: '04:15 PM', value: '04:15 PM' },
  { id: 67, label: '04:30 PM', value: '04:30 PM' },
  { id: 68, label: '04:45 PM', value: '04:45 PM' },
  { id: 69, label: '05:00 PM', value: '05:00 PM' },
  { id: 70, label: '05:15 PM', value: '05:15 PM' },
  { id: 71, label: '05:30 PM', value: '05:30 PM' },
  { id: 72, label: '05:45 PM', value: '05:45 PM' },
  { id: 73, label: '06:00 PM', value: '06:00 PM' },
  { id: 74, label: '06:15 PM', value: '06:15 PM' },
  { id: 75, label: '06:30 PM', value: '06:30 PM' },
  { id: 76, label: '06:45 PM', value: '06:45 PM' },
  { id: 77, label: '07:00 PM', value: '07:00 PM' },
  { id: 78, label: '07:15 PM', value: '07:15 PM' },
  { id: 79, label: '07:30 PM', value: '07:30 PM' },
  { id: 80, label: '07:45 PM', value: '07:45 PM' },
  { id: 81, label: '08:00 PM', value: '08:00 PM' },
  { id: 82, label: '08:15 PM', value: '08:15 PM' },
  { id: 83, label: '08:30 PM', value: '08:30 PM' },
  { id: 84, label: '08:45 PM', value: '08:45 PM' },
  { id: 85, label: '09:00 PM', value: '09:00 PM' },
  { id: 86, label: '09:15 PM', value: '09:15 PM' },
  { id: 87, label: '09:30 PM', value: '09:30 PM' },
  { id: 88, label: '09:45 PM', value: '09:45 PM' },
  { id: 89, label: '10:00 PM', value: '10:00 PM' },
  { id: 90, label: '10:15 PM', value: '10:15 PM' },
  { id: 91, label: '10:30 PM', value: '10:30 PM' },
  { id: 92, label: '10:45 PM', value: '10:45 PM' },
  { id: 93, label: '11:00 PM', value: '11:00 PM' },
  { id: 94, label: '11:15 PM', value: '11:15 PM' },
  { id: 95, label: '11:30 PM', value: '11:30 PM' },
  { id: 96, label: '11:45 PM', value: '11:45 PM' },
];

export const durationIntervals = [
  { label: '15 min', value: 15 },
  { label: '30 min', value: 30 },
  { label: '45 min', value: 45 },
  { label: '1 hour', value: 60 },
  { label: '1 hour 15 min', value: 75 },
  { label: '1 hour 30 min', value: 90 },
  { label: '1 hour 45 min', value: 105 },
  { label: '2 hours', value: 120 },
  { label: '2 hours 15 min', value: 135 },
  { label: '2 hours 30 min', value: 150 },
  { label: '2 hours 45 min', value: 165 },
  { label: '3 hours', value: 180 },
  { label: '3 hours 15 min', value: 195 },
  { label: '3 hours 30 min', value: 210 },
  { label: '3 hours 45 min', value: 225 },
  { label: '4 hours', value: 240 },
  { label: '4 hours 15 min', value: 255 },
  { label: '4 hours 30 min', value: 270 },
  { label: '4 hours 45 min', value: 285 },
  { label: '5 hours', value: 300 },
  { label: '5 hours 15 min', value: 315 },
  { label: '5 hours 30 min', value: 330 },
  { label: '5 hours 45 min', value: 345 },
  { label: '6 hours', value: 360 },
];

export const rangeIntervals = [
  { label: 'Next weekday', value: 'Next weekday' },
  { label: 'Next 2 weekdays', value: 'Next 2 weekdays' },
  { label: 'Next 3 weekdays', value: 'Next 3 weekdays' },
  { label: 'Next 4 weekdays', value: 'Next 4 weekdays' },
  { label: 'Next 5 weekdays', value: 'Next 5 weekdays' },
  { label: 'Next week (weekdays only)', value: 'Next week' },
  { label: 'Custom', value: 'Custom' },
  { label: 'Selected Option', value: 'Selected Option' },
];
